module.exports = __webpack_public_path__ + "img/Product5.d91d7e67.svg";